export default {"src":"/_next/static/media/secure.9babe66c.svg","height":1024,"width":1024};